import {
  Bookmark,
  Search,
  Briefcase,
  CheckCircle,
  SlidersHorizontal,
  Rocket,
  Share2,
} from "lucide-react";

/* Jobs list tour content, ported from the mobile "Jobs List" mockup. The
   per-card steps (save / apply / share) target the FIRST job card, which is
   the only one that carries the tour hooks. The generic GuidedTour engine
   renders these; this is just the data. */
export default function getJobsTourSteps() {
  return [
    {
      cardSelector: '[data-tour="jobs-save-top"]',
      targetSelector: '[data-tour="jobs-save-top"]',
      icon: <Bookmark />,
      title: "Save jobs",
      text: "Tap to save a job, then find all your saved jobs here.",
    },
    {
      cardSelector: '[data-tour="jobs-search"]',
      targetSelector: '[data-tour="jobs-search"]',
      icon: <Search />,
      title: "Search",
      text: "Find roles by job title or hospital.",
    },
    {
      cardSelector: '[data-tour="jobs-tabbar"]',
      targetSelector: '[data-tour="jobs-tab-jobs"]',
      icon: <Briefcase />,
      title: "Jobs",
      text: "Browse all open positions.",
    },
    {
      cardSelector: '[data-tour="jobs-tabbar"]',
      targetSelector: '[data-tour="jobs-tab-applied"]',
      icon: <CheckCircle />,
      title: "Applied Jobs",
      text: "Track the jobs you have applied to.",
    },
    {
      cardSelector: '[data-tour="jobs-filter"]',
      targetSelector: '[data-tour="jobs-filter"]',
      icon: <SlidersHorizontal />,
      title: "Filters",
      text: "Narrow results by pay, shift, job type and more.",
    },
    {
      cardSelector: '[data-tour="jobs-jobcard"]',
      targetSelector: '[data-tour="jobs-jc-save"]',
      icon: <Bookmark />,
      title: "Save",
      text: "Bookmark a job to revisit it later.",
    },
    {
      cardSelector: '[data-tour="jobs-jobcard"]',
      targetSelector: '[data-tour="jobs-jc-apply"]',
      icon: <Rocket />,
      title: "Apply now",
      text: "Apply directly to this listing.",
    },
    {
      cardSelector: '[data-tour="jobs-jobcard"]',
      targetSelector: '[data-tour="jobs-jc-share"]',
      icon: <Share2 />,
      title: "Share",
      text: "Send this job to a friend or colleague.",
    },
  ];
}
